// extracted by mini-css-extract-plugin
module.exports = {"header":"ChatBoxHeader_header__3xiOK","inverse":"ChatBoxHeader_inverse__PEt0_","close":"ChatBoxHeader_close__333LD"};